module.exports = __webpack_public_path__ + "img/arrow-left-long.7a031ae5.svg";